import React from 'react'
import FooterLogo from '../components/FooterLogo'


const AboutUs = () => {
  return (
    <>
    <div className="page-container col-sm-9 clearfix">
      <div id="rules-header">
        <div id="header-rules-text">
          <span className="count-down">About Open Play Tennis</span>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
            <div className="shadow-sm feedback-grey-box p-5">
            <p className='p-0 m-0'>Ready to experience the thrill of competitive match play? Looking for something new and exciting? Open Play Tennis is a web application that manages league / tournament play. Open Play Tennis allows you to set your own schedule, track your results, find new people to play and start beating them. The platform is user friendly, intuitive, has an interactive leader board, message board and the completed scoring history of all players. </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container mt-0">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Getting Started</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>
                  Register online. Select your home court and enter your rating. If you do not have a rating, you can self-rate for the first season. Your results will determine if you stay at your self-rated level. Registration is always free, and you can use the message system to communicate with other members.
                </p>
                <p>To enter league / tournament play, you will pay a nominal fee. The fee will be clearly posted. You will receive notification when registration is open for league play via email, banners on the Open Play Tennis website or both.</p>
                <p>League play is generally 4 weeks + a 16-player singles elimination playoff if you qualify. The top 16 players will qualify for the single elimination playoff based on ranking (see league scoring for information on ranking). You have a week to play each match. Your schedule will populate on the player profile page once the season begins.</p>
                <p>Contact your opponent via the online message system, schedule matches when it is convenient for both of you and post your results online
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Format</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Format for the league is two out of three traditional 6 games sets. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">League Scoring</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Scoring is not based on win / loss record, rather a point system. The point system for league play is as follows: </p>
                <div className="col-lg-6">
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Straight set match win</div>
                    <div className="col-4 pl-0">= 4 points</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Match win</div>
                    <div className="col-4 pl-0">= 3 points</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Opponent retired</div>
                    <div className="col-4 pl-0">= 3 points</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Default victory</div>
                    <div className="col-4 pl-0">= 2 points</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">BYE</div>
                    <div className="col-4 pl-0">= 2 points</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Losing player winning a set</div>
                    <div className="col-4 pl-0">= 1 point</div>
                  </div>
                  <div className="row pt-2">
                    <div className="col-6 pl-0">Players loses in straight sets</div>
                    <div className="col-4 pl-0">= 0 point</div>
                  </div>
                </div>
                <p className="pt-3">Players with the most points will rank higher on leaderboard. When players have the same points, tiebreakers for seeding are as follows:</p>
                <ul className="roman-numeric">
                  <li>i. Player with a greater number of wins will be higher in rank.</li>
                  <li>ii. If two players have an equal number of points and an equal number wins then the player with the higher percentage of games won will have the higher ranking. </li>
                  <li>iii. If percentage of games won are equal the player with fewer number of loses will be higher on leaderboard ranking.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">    
      <div className="col-lg-12">
        <div className="rules-box-container">
          <div className="heading-rule text-light">
            <h3 className="text-light p-0">Schedule / Scheduling</h3>           
          </div>
          <div className="msg-body-container rule-head shadow-sm">
            <div className="rule-subsection send-feedback-container pl-3">            
              <p>Remember the FIRST RULE and have fun.</p>              
            </div>
          </div>
        </div>      
      </div>
    </div> */}

      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Schedule / Scheduling</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Schedules will be available prior to the start of the season and are posted within 24 hours of registration closing. Players will have two home matches and two away matches. Some players may have a "bye" during the four-week season.</p>
                <p>You have a week to complete each match. It is the responsibility of the home court player to initiate contact with his/her opponent. Use the online message system to contact your opponent. To make scheduling easier, you may want to exchange phone numbers.</p>
                <p>If a player cannot play, the player who can play has the option of rescheduling or taking a default victory. Please make every effort to play each match - even if rescheduling is required</p>
                <p>If both players agree, you may play matches before the scheduled date. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Eligibility</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Open Play Tennis is open to both male and female players. The only requirement is a rating. USTA or UTR ratings are preferred, but you can self-rate for the first season. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Levels</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Player will be bracketed into levels based on rating. We have levels for 2.5 - 5.0 players. Players may opt to play up one level, but players are not allowed to play down. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Division Size</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>If less than 6 players register for a division, players will be notified via email and given the option to continue play or receive a refund.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Age</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>We ask that you be at least 13 to play in the Open Play Tennis League.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Courts</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Select your home court from the registration page. The Open Play Tennis administer will verify the court. Once the administrator verifies the court, the court will appear on your player Profile Page and Court Page. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Court Fees</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Please choose a court that does not require a fee. If you do select a court that requires a fee, you are responsible for paying for opponent as well as yourself. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Playoffs</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Top 16 players from each level qualify for the playoffs. See Rules for tie-breaker information. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Cost</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>The enter league / tournament play, you will pay a nominal fee. The fee will be clearly posted. You will receive notification when registration is open for league play via email, banners on the Open Play Tennis website or both. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Commitment</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>If you sign up to beat Joe, then you are committing to play ALL matches even if you are out of playoff contention. If you fail to finish the season you may be subjected to a ban from league play at the sole discretion of the tournament director. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Entry Deadline</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>Entry deadline will be clearly posted on the website.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="rules-box-container">
            <div className="heading-rule text-light">
              <h3 className="text-light p-0">Withdrawal From League / Refunds</h3>
            </div>
            <div className="msg-body-container rule-head shadow-sm">
              <div className="rule-subsection send-feedback-container pl-3">
                <p>You may request a refund up to close of registration. After the start of the season, you may request a credit if you can no longer participate.  Credits will only be granted for verifiable injuries or other health complications. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div className='footer_space'></div>
      <FooterLogo />
    </>
  )
}

export default AboutUs